export enum OPEnum {
  OP = "overview",
  CORNERSTONE = "cornerstone",
  CROSSROADS = "crossroads",
  AVATAR = "avatar-of-the-realm",
}
